import { gql } from "@apollo/client";

const USER_FIELDS = gql`
  fragment SuggestedFollowersUserFields on User {
    _id
    avatar
    username
    steam {
      steamid
      personaname
    }
    userGroup {
      type
    }
  }
`;

const SUGGESTED_FOLLOWERS = (useGraphQuery: boolean) => gql`
  ${USER_FIELDS}

  ${useGraphQuery
    ? `
    query getMe($count: Int) {
      me {
        suggestions(limit: $count) {
          user { 
            ...SuggestedFollowersUserFields 
          }
          reason
          score
        }
      }
    }
  `
    : `
    query suggestedCreators($count: Int) {
      suggestedCreators(count: $count) {
        reason
        user {
          ...SuggestedFollowersUserFields
        }
      }
    }
  `}
`;

export { SUGGESTED_FOLLOWERS };
